import { Form } from 'antd';
import { CategoriesUI, ServicesUI } from 'features/booking/BookingOnlineV2/ServiceUI';
import { first } from 'lodash';
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { ICategoryItemData } from 'services/shop/types/categories';
import styled from 'styled-components';
import useQueryServicesByStaff from './useQueryServicesByStaff';
import { useSearchParams } from 'react-router-dom';

type ServiceByStaffStepProps = {
  name?: any;
  v4?: boolean;
};
export type ServiceByStaffStepRef = {
  fetch: (staffId?: string) => void;
};
export const serviceByStaffStepRef = React.createRef<ServiceByStaffStepRef>();
const ServiceByStaffStep = forwardRef<ServiceByStaffStepRef, ServiceByStaffStepProps>(({ name, v4 }, ref) => {
  const [_activeCategory, setActiveCategory] = useState<ICategoryItemData | null>(null);
  const form = Form.useFormInstance();
  const _categoriesData = Form.useWatch(['categories'], form);
  const [searchParams] = useSearchParams();
  const initialServiceId = searchParams.get('serviceId');
  const [serviceState, fetch] = useQueryServicesByStaff({
    onStart() {
      form.resetFields(['SERVICE_VALID']);
    },
    onDone(data) {
      form.setFieldValue('categories', data);
    },
  });
  const categories: ICategoryItemData[] = useMemo(() => serviceState.data?.length ? serviceState.data : (_categoriesData || []), [serviceState, _categoriesData]);

  const handleFetch = async (staffId?: string) => {
    fetch(staffId);
  };

  const activeCategory = useMemo(() => {
    if (!_activeCategory) return first(categories) || null;
    return _activeCategory;
  }, [_activeCategory, categories]);

  useImperativeHandle(ref, () => ({
    fetch: handleFetch,
  }));

  useEffect(() => {
    if (!_activeCategory && initialServiceId && categories?.length) {
      const activeCategory = categories.find(cat =>
        cat.services.some(s => s.id === initialServiceId)
      );

      if (activeCategory) {
        setActiveCategory(activeCategory);
      }
    }
  }, [initialServiceId, categories]);

  return (
    <>
      <Container>
        <Form.Item noStyle name={[name, 'services']} rules={[{ required: true, message: 'Please choose services' }]}>
          <CategoriesUI activeId={activeCategory?.id || ''} categories={categories} onChooseCate={setActiveCategory} />
        </Form.Item>
        <Form.Item noStyle name={[name, 'services']}>
          <ServicesUI services={activeCategory?.services || []} v4={v4}/>
        </Form.Item>
      </Container>
    </>
  );
});
ServiceByStaffStep.displayName = 'BookingV2ServiceByStaffStep';
export default ServiceByStaffStep;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
